import { gql, useLazyQuery } from "@apollo/client";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import useFetchTableData from "../../../custom_hooks/useFetchTableData";
import useProcessData from "../../../../CommonFunction/ProcessData";
import { Loading, LoadTable } from "../../../Components";

const queryFunction = (fields, Refetch) => {
  const query = gql`
    query GetCompanyTransactionHistory($fromCached: Boolean=${!Refetch}) {
        getCompanyTransactionHistory(fromCached: $fromCached) {
          _id
          ${fields?.join(" ")}
        }
      }`;
  return query;
};

const CompanyTransactionsView = () => {
  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let refresh = useSelector((store) => store?.FormFieldData?.refresh);
  const Key = "CompanyTransactionHistoryTable";
  console.log("call");
  const config = useMemo(
    () => ({
      dataKey: "getCompanyTransactionHistory",
    }),
    []
  );

  const [fetchCompanyTransactionHistory, { loading: queryLoading, error, data }] = useLazyQuery(
    queryFunction([], refresh),
    {
      fetchPolicy: "network-only",
      onCompleted: () => {
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
    }
  );

  const { TableHeaders } = useFetchTableData(queryFunction, fetchCompanyTransactionHistory, setIsLoading, Key);

  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error, formData);
  const isLoading1 = processDataLoading || isLoading;

  return (
    <div>
      {isLoading1 || queryLoading ? (
        <Loading />
      ) : formData.length === 0 ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {queryLoading && <div className="loader-line-div" />}
          <LoadTable data={formData} loading={isLoading1} error={error} title={Key} TableHeaders={TableHeaders} />
        </>
      )}
    </div>
  );
};

export default CompanyTransactionsView;
